import { handleWeeklyVersion, handleWeeklyVersionModel } from '@op/services';
import { useState } from 'react';
import { ParamsType, VisibleType } from '../type';

export function useHandleOperationParams() {
  const [visible, setVisible] = useState<VisibleType>();
  const [params, setParams] = useState();
  const [type, setType] = useState<ParamsType>();

  function handOperation(visible: VisibleType, type: ParamsType, params: any) {
    setParams(params);
    setVisible(visible);
    setType(type);
  }

  function addVersion() {
    handOperation('add', 'version', null);
  }

  function closeModal() {
    setVisible(undefined);
    setParams(undefined);
    setType(undefined);
  }

  return {
    visible,
    params,
    type,
    handOperation,
    closeModal,
    addVersion,
  };
}

export default function useHandleOperation({
  callBack,
  gameInfo,
  type,
  closeModal,
  params,
}: {
  callBack: (type: 'success' | 'error') => void;
  gameInfo: any;
  type?: ParamsType;
  params: any;
  closeModal: () => void;
}) {
  const [loading, setLoading] = useState(false);
  function handleModules(params: any) {
    setLoading(true);

    handleWeeklyVersionModel({
      data: {
        ...params,
        ...gameInfo,
        game_id: gameInfo.edition_unified_id,
      },
    })
      .then(() => {
        callBack('success');
      })
      .catch(() => {
        callBack('error');
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleVersion(params: any) {
    setLoading(true);
    handleWeeklyVersion({
      data: { ...params, ...gameInfo, game_id: gameInfo.edition_unified_id },
    })
      .then(() => {
        callBack('success');
      })
      .catch(() => {
        callBack('error');
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function confirmDelete() {
    if (type === 'module') {
      handleModules(params);
    } else {
      handleVersion(params);
    }
    closeModal();
  }

  return {
    handleModules,
    handleVersion,
    confirmDelete,
    loading,
  };
}
